import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import BecaEstudiantil from "./BecaEstudiantil";
import EstBecados from './EstBecados';

class BienestarMain extends Component {
    state = {
        valorActividad: { value: 'beca_estudiantil', label: 'Beca Estudiantil' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/bienestar_estudiantil/beca_estudiantil":
                return({ value: 'beca_estudiantil', label: 'Beca Estudiantil' })
            case "/bienestar_estudiantil/estudiantes_becados":
                return({ value: 'estudiantes_becados', label: 'Estudiantes Becados' })
            default:
                return({ value: 'beca_estudiantil', label: 'Beca Estudiantil' })
        }
    }

    valorEstadosLabel = (link) => {
        switch (link) {
            case "/bienestar_estudiantil/beca_estudiantil": return('Beca Estudiantil')
            case "/bienestar_estudiantil/estudiantes_becados": return('Estudiantes Becados')
            default: return('Beca Estudiantil')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/bienestar_estudiantil/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/bienestar_estudiantil/beca_estudiantil" component={ () => <BecaEstudiantil/> } />
                <Route path="/bienestar_estudiantil/estudiantes_becados" component={ () => <EstBecados/> } />
                <Redirect to = "/bienestar_estudiantil/beca_estudiantil" />
            </Switch>
        )
    }

    render() { 
        const Opciones = [
            { value: 'beca_estudiantil', label: 'Beca Estudiantil' },
            /* { value: 'estudiantes_becados', label: 'Estudiantes Becados' }, */
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una actividad
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorEstadosLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default BienestarMain;


// WEBPACK FOOTER //
// ./src/views/Bienestar/BienestarMain.jsx